import { connect } from "react-redux";
import OvAccountsInfoActions from "./OvAccountsInfoActions";
import {
  setSuccessNotification,
  setErrorNotification
} from "./actions/notifications";
import { sendToSheetAction } from "./actions/sheets";

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClipboardEvent: (type, evt) => {
      if (type !== "ERROR") {
        const message = `Sucessfully copied ${type} data to the clipboard`;
        dispatch(setSuccessNotification(message));
        return;
      }
      dispatch(setErrorNotification({ message: "Failed to copy" }, evt));
    },
    sendToSheet(range, data, tableInfo) {
      dispatch(sendToSheetAction(range, data, tableInfo));
    }
  };
};

const OvAccountsInfoActionsContainer = connect(null, mapDispatchToProps)(
  OvAccountsInfoActions
);

export default OvAccountsInfoActionsContainer;



// WEBPACK FOOTER //
// ./src/OvAccountsInfoActionsContainer.js